<template>
  <div class="home-right-bottom">
    <div class="list-box">
      <div class="list-item" v-for="tab in visibleTabList" :key="tab.value"
        :class="{ 'item-active': activedTab === tab.value }" @click="changeTab(tab.value)">
        <div class="item-label">{{ tab.label }}</div>
        <!-- <div class="item-count">{{ tab.count | taskCountFormat }}</div> -->
      </div>
    </div>
    <div class="tab-content" v-loading="isLoading">
      <!--OA申请卡片 -->
      <RemoteWrapper ref="oa" moduleName="flow/FlowHomeFlowNew" v-show="activedTab === 'oa'"
        @total-change="handleTotalChange" />
      <!--工单卡片 -->
      <RemoteWrapper ref="kts" moduleName="kts/KtsHomeGdList" v-show="activedTab === 'kts'"
        @total-change="handleTotalChange" />
      <!--我的任务卡片 -->
      <RemoteWrapper ref="task" moduleName="bss_ams/BssMyTask" v-show="activedTab === 'task'"
        @total-change="handleTotalChange" />
    </div>
  </div>
</template>

<script>
// 远程组件包装器
import RemoteWrapper from './remote-wrapper.vue'
export default {
  components: {
    RemoteWrapper
  },
  data() {
    return {
      activedTab: 'oa',
      tabList: [
        { label: 'OA申请', value: 'oa', count: 0, isShow: true },
        { label: '工单', value: 'kts', count: 0, isShow: true },
        { label: '我的任务', value: 'task', count: 0, isShow: false }
      ],
      isLoading: false
    }
  },
  computed: {
    visibleTabList() {
      return this.tabList.filter(tab => tab.isShow)
    }
  },
  watch: {
    visibleTabList(tabs) {
      if (!tabs.find(tab => tab.value === this.activedTab)) {
        this.activedTab = tabs[0] ? tabs[0].value : ''
      }
    }
  },
  filters: {
    /**
     * 任务数量格式化
     */
    taskCountFormat(count) {
      return count > 99 ? '99+' : count || ''
    }
  },
  methods: {
    /**
     * 切换tab
     */
    changeTab(value) {
      this.activedTab = value
      this.loadData()
    },
    /**
     * 任务数量改变
     */
    handleTotalChange({ total, type, isShow }) {
      this.isLoading = false
      const tab = this.tabList.find(item => item.value === type)
      tab.count = total
      if (isShow !== undefined) {
        tab.isShow = isShow
      }
    },
    /**
     * 加载数据
     */
    loadData() {
      if (this.isLoading) return
      this.isLoading = true
      const ref = this.$refs[this.activedTab]
      ref && ref.loadData && ref.loadData()
    }
  }
}

</script>
<style lang="scss" scoped>
@font-face {
  src: url('./Gilroy-ExtraBoldItalic-10.otf');
  font-family: 'Gilroy';
  font-weight: bold;
  font-style: normal;
  font-weight: 500;
}
.home-right-bottom {
  box-shadow: 0 -10px 10px -5px rgba(0, 0, 0, 0.035);
  background: rgba(255, 255, 255, 0.4);
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 0 0 12px 12px;
  z-index: 101;

  .list-box {
    display: flex;
    align-items: center;
    height: 42px;
    box-sizing: border-box;
    border-radius: 12px 12px 0 0;
    border: 1px solid #fff;
    border-bottom: 0;
    background: rgba(255, 255, 255, 0.4);

    .list-item {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 42px;
      box-sizing: border-box;
      flex: 1;
      // background: rgba(255, 255, 255, 0.4);
      cursor: pointer;

      &::before {
        content: "";
        width: 1px;
        height: 9px;
        background: rgba(68, 62, 82, 1);
        opacity: 0.2;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      .item-label {
        color: #453c5a;
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        margin-right: 4px;
      }

      .item-count {
        font-family: 'Gilroy';
        color: #443e52;
        font-size: 18px;
        font-weight: 800;
        line-height: 24px;
        transform: skew(-5deg);
      }
    }

    .list-item:first-child {
      &::before {
        display: none;
      }
    }

    .list-item:first-child.item-active {
      box-shadow: 10px 0 5px -5px rgba(0, 0, 0, 0.04);
    }

    .list-item:last-child.item-active {
      box-shadow: -10px 0 5px -5px rgba(0, 0, 0, 0.04);

      &::after {
        display: none;
      }
    }

    .item-active {
      background-color: #fff;
      position: relative;
      border-radius: 12px 12px 0px 0px;
      box-shadow: 10px 0 5px -5px rgba(0, 0, 0, 0.04),
        -10px 0 5px -5px rgba(0, 0, 0, 0.04);

      .item-label,
      .item-count {
        color: #8757f9;
      }

      &::after {
        content: "";
        width: 16px;
        height: 16px;
        background-image: url("../images/left.png");
        background-size: 100% 100%;
        position: absolute;
        bottom: 0px;
        right: -16px;
      }

      &::before {
        content: "";
        width: 16px;
        height: 16px;
        background-image: url("../images/right.png");
        background-size: 100% 100%;
        position: absolute;
        bottom: 0px;
        left: -16px;
        background-color: transparent;
        top: auto;
        transform: none;
        opacity: 1;
      }
    }

    .item-active+.list-item {
      &::before {
        display: none;
      }
    }
  }

  .tab-content {
    flex: 1;
    display: flex;
    width: 100%;
    overflow: hidden;
    box-shadow: 0 -10px 10px -5px rgba(0, 0, 0, 0.02);
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/my-workbench/index.vue